import { render, staticRenderFns } from "./riskAssessmentTemplateForm.vue?vue&type=template&id=4eb19ad4"
import script from "./riskAssessmentTemplateForm.vue?vue&type=script&lang=js"
export * from "./riskAssessmentTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports